import { InternalInvoiceResponseV3 } from '@payer-admin-ui/api/src/invoices/responses/InvoiceResponseV3';
import { MappingType } from '@payer-admin-ui/api/src/bankfilepayments/bankFilePaymentTypes';
import { type FilterState } from '@payer-admin-ui/components-v2/src/types/state';
import { type MappingTargetType } from 'utils/constants';
import { emptyInvoiceFilters, type InvoiceFilters } from 'views/Pages/invoices/invoicesGlobalState';
import {
  emptyIAFilters,
  type InvoiceAggregationsFilters,
} from 'views/Pages/invoiceAggregations/invoiceAggregationsGlobalState';
import { PaymentStatus } from '@payer-admin-ui/api/src/invoices/models/PaymentStatus';
import { GetInvoiceStatementBasicsResponse } from '@payer-admin-ui/api/src/ui/invoicestatements/responses/GetInvoiceStatementBasicsResponse';
import { defaultSerializeDate, oneYearBack } from '@payer-admin-ui/components-v2/src/utils/dates';

export type InvoiceSearchResultItem = {
  type?: MappingTargetType;
  number: string;
  customerName?: string;
  currencyCode: string;
  balance?: string;
  originalAmount?: string;
  paymentStatus: PaymentStatus;
  invoiceDate?: string;
  dueDate?: string;
  feeBalance?: string;
  reference?: string;
  invoice?: InternalInvoiceResponseV3;
};

export type StatementSearchResultItem = {
  number: string;
  ocrNumber: string;
  currencyCode: string;
  numberOfInvoices: number;
  customerCompany?: string;
  originalAmount?: string;
  balance?: string;
  dueDate?: string;
  statement: GetInvoiceStatementBasicsResponse;
};

export type DraftInvoiceMapping = {
  id: string;
  type?: MappingTargetType;
  mappingType: MappingType;
  number?: string;
  amount: number;
  isAiSuggested?: boolean;
  isConfirmed?: boolean;
  error?: string;
};

export type DraftStatementMapping = {
  id: string;
  number?: string;
  amount: number;
  isConfirmed?: boolean;
  error?: string;
};

export type AddMappingMode = 'INVOICE' | 'STATEMENT';

export type AddMappingModalState = {
  isFetching?: boolean;
  error?: any;
  success?: boolean | null;
  mode: AddMappingMode;
  invoice: {
    search: {
      isFetching: boolean;
      error: any;
      results: InvoiceSearchResultItem[];
      query: string;
    };
    draftMappings: Record<string, DraftInvoiceMapping>;
    filters: FilterState<InvoiceFilters>;
  };
  statement: {
    search: {
      isFetching: boolean;
      error: any;
      results: StatementSearchResultItem[];
      query: string;
    };
    draftMappings: Record<string, DraftStatementMapping>;
    filters: FilterState<InvoiceAggregationsFilters>;
  };
};

export const initialFilters: InvoiceFilters = {
  ...emptyInvoiceFilters,
  paymentStatus: [PaymentStatus.UNPAID, PaymentStatus.PARTIALLY_PAID, 'OVERDUE'],
  invoiceDateStart: defaultSerializeDate(oneYearBack()),
  partOfInvoiceAggregation: false,
};

export const initialState: AddMappingModalState = {
  isFetching: false,
  error: null,
  success: null,
  mode: 'INVOICE',
  invoice: {
    search: { isFetching: false, error: null, results: [], query: '' },
    draftMappings: {},
    filters: {
      filters: initialFilters,
      appliedFilters: initialFilters,
    },
  },
  statement: {
    search: { isFetching: false, error: null, results: [], query: '' },
    draftMappings: {},
    filters: {
      filters: emptyIAFilters,
      appliedFilters: emptyIAFilters,
    },
  },
};
